const SUPPORT_EMAIL = "hello@evograding.com";

const commonTopics = [
  {
    title: "Account login issues",
    response:
      "Confirm you are using the same email and sign-in method you used when creating your account. If you are still locked out, email us with your account email and the device you are using.",
  },
  {
    title: "Subscription or billing questions",
    response:
      "Subscriptions are managed through your Apple ID. You can restore purchases in Evo settings or manage billing in Apple ID subscriptions. For anything unclear, email us with your account email.",
  },
  {
    title: "AI grading issues",
    response:
      "If a grade looks wrong, email us with your account email, the card name, the image used, and a short description of what seemed off.",
  },
  {
    title: "Card upload or image problems",
    response:
      "Use a clear, well-lit photo with the whole card visible. If uploads still fail, email us with your account email, device model, and what happened.",
  },
  {
    title: "Deleting your account or data",
    response:
      "You can use the in-app delete account option under settings. You can also email us from your account email and ask us to delete your account or data.",
  },
];

export default function Support() {
  return (
    <div className="min-h-screen bg-[#faf9fb] text-[#07001a]">
      <header className="mx-auto flex w-full max-w-[960px] items-center justify-between px-6 py-5">
        <a
          className="font-['Figtree',sans-serif] text-[20px] font-black text-[#07001a] no-underline"
          href="/"
        >
          evo
        </a>
        <nav className="flex items-center gap-4">
          <a
            className="font-['Figtree',sans-serif] text-[14px] font-semibold text-[#776f7b] no-underline hover:text-[#07001a]"
            href="/privacy"
          >
            Privacy
          </a>
          <a
            className="font-['Figtree',sans-serif] text-[14px] font-semibold text-[#776f7b] no-underline hover:text-[#07001a]"
            href="/terms"
          >
            Terms
          </a>
        </nav>
      </header>

      <main className="mx-auto w-full max-w-[840px] px-6 pb-16 pt-8">
        <article className="terms-content">
          <h1>Evo Support</h1>

          <p>
            Need help with Evo? Contact us at:{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>

          <h2>Common Topics</h2>
          <div className="support-topic-list">
            {commonTopics.map((topic) => (
              <details className="support-topic" key={topic.title}>
                <summary>{topic.title}</summary>
                <p>
                  {topic.response} Email{" "}
                  <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
                </p>
              </details>
            ))}
          </div>

          <h2>Frequently Asked Questions</h2>

          <h3>How do I restore my subscription?</h3>
          <p>
            Open Evo -&gt; Settings -&gt; Manage Subscription / Restore Purchases.
          </p>

          <h3>How do I cancel my subscription?</h3>
          <p>
            Subscriptions are managed through your Apple ID: Settings -&gt; Apple
            ID -&gt; Subscriptions -&gt; Evo.
          </p>

          <h3>How do I report a grading issue?</h3>
          <p>
            Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> with
            your account email and a short description of the issue.
          </p>

          <h3>How do I delete my account?</h3>
          <p>
            Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> or use
            the in-app delete account option under settings.
          </p>

          <h2>Legal</h2>
          <p>
            Privacy Policy: <a href="/privacy">/privacy</a>
            <br />
            Terms of Use: <a href="/terms">/terms</a>
          </p>
        </article>
      </main>
    </div>
  );
}
